import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// This must be the first line in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import configureStore from './redux/store';
import * as serviceWorker from './serviceWorker';
import App from './App';

// Note: not all bootstrap css features are currently enabled (to keep the css file as small as possible)
// If you need a feature which isnt enabled, un-comment it in this override file.
import './scss/bootstrap-override.scss';
import './scss/fonts.scss';
import './index.scss';

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
